module.exports = __webpack_public_path__ + "img/32.ee56f285.png";